import { defineStore } from "pinia";
import axiosClient from "../axios.js";
import { servicesLayout } from "@/data/layouts.js";

export const useServiceStore = defineStore("service", {
    state: () => ({
        // ==================== states used on services page and its relation
        allServices: null,
        services: null,
        searchBar: {select: {title: 'All Services', value: 'all'}, input: {value: null}},
        categories: null,
        servicesShow: null,
        layouts: null,
        serviceDetail: null
    }),
    getters: {
        // ==========
    },
    actions: {
        // ==================== actions used on services page and its relation
        async setServices(){
            try{
                this.layouts = servicesLayout;
                const response = await axiosClient.get(`service`);
                const category = await axiosClient.get(`service/category`);
                this.allServices = response.data.data;
                this.services = response.data.data;
                this.categories = category.data.data;
                this.showServices(6);
                // console.log(this.categories);
                // console.log(response);
                // console.log(this.services);
                // console.log(this.layouts);
            }catch(error){
                console.log(error);
            }
        },
        async setServiceDetail(slug){
            this.serviceDetail = null;
            try{
                var detail = null;
                const response = await axiosClient.get(`service/` + slug);
                detail = {head: {small_title: 'Our Great Services', title: response.data.name, description: null}, body: {image: response.data.image, description: response.data.description}};
                this.serviceDetail = detail;
                // console.log(response.data);
                // console.log(this.serviceDetail);
            }catch(error){
                console.log(error);
            }
        },
        showServices(limit){
            this.servicesShow = this.services.slice(0, limit);
            // console.log(this.servicesShow);
        },
        moreServices(){
            const ln = this.servicesShow.length;
            this.showServices((ln + 6));
        },
        searchbarSelect(category, slug){
            this.searchBar.select.title = category;
            this.searchBar.select.value = slug;
            this.searchService();
            // console.log(this.searchBar);
            // console.log(this.allServices);
        },
        searchbarInput(value){
            this.searchBar.input.value = value;
            this.searchService();
        },
        searchService(){
            var newsd = [];
            if(this.searchBar.select.value != 'all'){ // if selected specialist
                for(var i = 0; i < this.allServices.length; i++){
                    if(this.allServices[i].category == this.searchBar.select.title){
                        newsd.push(this.allServices[i]);
                    }
                }
            }else{
                newsd = this.allServices;
            }
            if(this.searchBar.input.value){
                var result = [];
                var inval = new RegExp(this.searchBar.input.value, 'gi');
                // var thisservices = [];
                for(i = 0; i < newsd.length; i++){
                    if(newsd[i].name.match(inval)){
                        result.push(newsd[i]);
                    }
                    // for(var j = 0; j < newsd[i].doctor.length; j++){
                    //     if(newsd[i].doctor[j].name.match(inval)){
                    //         thisdocs.push(newsd[i].doctor[j]);
                    //     }
                    // }
                    // if(result.length > 0){
                    //     result.push({name: newsd[i].name, slug: newsd[i].slug, doctor: thisdocs});
                    // }
                }
                this.services = result;
            }else{
                this.services = newsd;
            }
            this.showServices(6);
            // console.log(this.services);
        }
    }
});